import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'shift' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/shift.js.map
